/**
 * Created by Administrator on 2017/10/27.
 */
import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {HttpService} from "../service/http-service";
import {FileUpload} from "../service/file-upload";
import {API} from "../config/api-config";
declare var alertify:any;
@Component({
  templateUrl:'./editBanner.html'
})

export class EditProductBanner implements OnInit{
  constructor(
    private router:Router,
    private route:ActivatedRoute,
    private HttpService:HttpService,
    private fileupload:FileUpload,
    private location:Location
  ){}


  private data:any={
    'id':'',
    'image':'',
    'updatedBy':'',
    'updatedTime':''
  }

  private id:number = 0;
  private imagePath:string='';
  private isCreate:boolean=false;
  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id=params['id'];
    });

    if(this.id!=0){
      this.getPath();
      this.getData();
    }else {
      this.isCreate=true;
    }
  }

  private getData():void{
    this.HttpService.getData(API.productBanner+'/'+this.id).then(res=>{
      this.data = res.data;
    })
  }

  // 获取路径
  private getPath():void{
    this.HttpService.getData(API.resourcePath)
      .then(res=>{
        this.imagePath=res.data;
        console.log(res.data)
      })
  }

  private submit():void{
    this.HttpService.postData(API.productBanner,{
      'id':this.id,
      'image':this.data.image
    }).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
        this.location.back();
        alertify.success(data.status.message);
      }else{
        alertify.error(data.status.message);
      }
    });
  }

  private showIconEn:boolean = false;
  private tempPath:string=API.getTemp;
  private upload(name:string){
    let self=this;
    this.fileupload.upload(function (res) {
      let temRes=JSON.parse(res);
      if(temRes.status.code==0){
        switch (name){
          case 'image':self.showIconEn=true;break;
        }
        self.data[name]=temRes.data.fileName;
      }
    });
  }

}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/productBanner/ProductBannerEdit.component.ts